module.exports = __webpack_public_path__ + "static/media/sopt28kz.05eb0fc1.pdf";